import {apiClient} from "../../client/connection/BlinkApiClient.js";
import {iFrameState} from "./IFrameState.js";
import {iFrameMerchantService} from "./IframeMerchantService.js";
import {getAnalyticsClient} from "../../blink-sdk/utils/AnalyticsClient.js";

// TODO: We probably want to generate this list automatically from the API.
//  These are the endpoints that receive a request extending
//  MerchantConversionRequest.
// TODO @branch add purchases
const CONVERSION_METADATA_ENDPOINTS = [
    "/payment_methods/add_payment_method",
    "/payment_methods/dev_add_payment_method",
    "/payments/purchase_product",
    "/user_addresses/create",
    "/donations/donate",
    "/subscriptions/subscribe",
    "/subscriptions/update_subscription",
    "/payments/purchase_product",
    "/external_providers/login_with_cds",
    "/external_providers/subscribe_with_cds",
    "/external_providers/donate_with_cds",
    "/users/login",
    "/users/update_newsletter_subscriptions",
    "/users/request_email_login_code",
    "/users/login_with_email_code",
    "/users/give_merchant_consent",
    "/users/request_email_change",
    "/users/confirm_email_change",
    // TODO @cleanup simplify this list so it isn't so explicit
    "/socialauth/google",
    "/socialauth/facebook",
    "/socialauth/linkedin",
    "/socialauth/github",
    "/socialauth/twitter/connect",
    "/socialauth/confirm_social_signup",
];

// TODO Centralize where all these API pre and post processors are added, to control the order
export function addMetadataAPIPreprocessor() {
    apiClient.ajaxHandler.addPreprocessor((options, input) => {
        let url = (new URL(input instanceof Request ? input.url : input)).pathname;

        // Remove any extra trailing /
        if (url.endsWith("/") && url !== "/") {
            url = url.slice(0, -1);
        }
        if (CONVERSION_METADATA_ENDPOINTS.indexOf(url) >= 0) {
            const analyticsEnvironment = getAnalyticsClient()?.environment ?? {};

            options.data = options.data || {};
            options.data.merchantId = iFrameMerchantService.merchantId;
            options.data.metadata = {
                ...analyticsEnvironment,
                ...iFrameState.getMetadata(),
                ...options.data.metadata,
            };

            delete options.data.metadata.journeys;
            if (analyticsEnvironment.journeys) {
                options.data.activeJourneys = analyticsEnvironment.journeys;
            }
        }
    });
}
